import BillingsOrderCargoTaxiRecalculateRequest, {
  BillingsOrderCargoTaxiRecalculateRequestBillingNode,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionBaseAmount,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionType,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionChargeHaltings,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountBeingLate,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOptimization,
  BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOther,
  BillingsOrderCargoTaxiRecalculateRequestBillingContribution,
} from "../../../../../api/raily/billings/order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate.request";
import BillingsOrderCargoTaxiRecalculateParams, {
  BillingsOrderCargoTaxiRecalculateParamsBillingNode,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionBaseAmount,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionChargeHaltings,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionContractCorrectionPercentage,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountBeingLate,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountIncompatibleCar,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOptimization,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOther,
  BillingsOrderCargoTaxiRecalculateParamsBillingContribution,
  BillingsOrderCargoTaxiRecalculateParamsBillingContributionType,
} from "./billings-order-cargo-taxi-recalculate-params";

const createBillingNode = (
  node: BillingsOrderCargoTaxiRecalculateParamsBillingNode,
): BillingsOrderCargoTaxiRecalculateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinated: node.editableCoordinated,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    plannedDistance: node.plannedDistance,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderCargoTaxiRecalculateParamsBillingNode[],
): BillingsOrderCargoTaxiRecalculateRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createBillingContributionBaseAmount = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionBaseAmount,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionBaseAmount => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.BASE_AMOUNT,
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
  };
};

const createBillingContributionChargeHaltings = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionChargeHaltings,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionChargeHaltings => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.CHARGE_HALTING,
    comment: contribution.comment,
    amount: contribution.amount,
    distance: contribution.distance,
  };
};

const createBillingContributionContractCorrectionPercentage = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionContractCorrectionPercentage,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionContractCorrectionPercentage => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE,
    comment: contribution.comment,
    amount: contribution.amount,
    percentage: contribution.percentage,
  };
};

const createBillingContributionDiscountBeingLate = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountBeingLate,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountBeingLate => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_BEING_LATE,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountIncompatibleCar = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountIncompatibleCar,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountIncompatibleCar => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountOptimization = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOptimization,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOptimization => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_OPTIMIZATION,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContributionDiscountOther = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOther,
): BillingsOrderCargoTaxiRecalculateRequestBillingContributionDiscountOther => {
  return {
    type: BillingsOrderCargoTaxiRecalculateRequestBillingContributionType.DISCOUNT_OTHER,
    comment: contribution.comment,
    amount: contribution.amount,
  };
};

const createBillingContribution = (
  contribution: BillingsOrderCargoTaxiRecalculateParamsBillingContribution,
): BillingsOrderCargoTaxiRecalculateRequestBillingContribution => {
  switch (contribution.type) {
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.BASE_AMOUNT:
      return createBillingContributionBaseAmount(contribution);
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.CHARGE_HALTING:
      return createBillingContributionChargeHaltings(contribution);
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE:
      return createBillingContributionContractCorrectionPercentage(
        contribution,
      );
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_BEING_LATE:
      return createBillingContributionDiscountBeingLate(contribution);
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR:
      return createBillingContributionDiscountIncompatibleCar(contribution);
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_OPTIMIZATION:
      return createBillingContributionDiscountOptimization(contribution);
    case BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_OTHER:
      return createBillingContributionDiscountOther(contribution);
  }
};

const createBillingContributions = (
  contributions: BillingsOrderCargoTaxiRecalculateParamsBillingContribution[],
): BillingsOrderCargoTaxiRecalculateRequestBillingContribution[] => {
  return contributions.map(createBillingContribution);
};

const create = (
  params: BillingsOrderCargoTaxiRecalculateParams,
): BillingsOrderCargoTaxiRecalculateRequest => {
  return {
    orderUuid: params.orderUuid,
    billingNodes: createBillingNodes(params.billingNodes),
    billingContributions: createBillingContributions(
      params.billingContributions,
    ),
  };
};

const billingsOrderCargoTaxiRecalculateParamsFactory = {
  create,
};

export default billingsOrderCargoTaxiRecalculateParamsFactory;
